import CartSummary from './quickShop/CartSummary';
import ItemFF from './quickShop/ItemFF';

const ProductQuickShopTemplate = (props) => {
  const { products, settings, cart } = props;
  return (
    <>
      <div className="c7-product-quickshop">
        {products.map((product, index) => {
          const analytics = {
            view: 'Quick Shop',
            position: index + 1,
            totalProducts: products.length
          };
          return (
            <ItemFF
              cart={cart}
              product={product}
              settings={settings}
              key={product.id}
              analytics={analytics}
            />
          );
        })}
      </div>
      <CartSummary cart={cart} settings={settings} />
    </>
  );
};

export default ProductQuickShopTemplate;
